export default __webpack_public_path__ + "static/media/logo.d567ee1a.svg";